import Service, { inject as service } from '@ember/service';
import DS from 'ember-data';
import { equal } from '@ember/object/computed';
import { task } from 'ember-concurrency';
import _sortBy from 'lodash.sortby';

import EnvironmentService from 'cio/services/environment';
import ApiCredentialModel from 'cio/models/api-credential';

export default class ApiCredentialsService extends Service {
  @service store!: DS.Store;
  @service environment!: EnvironmentService;

  credentials: ApiCredentialModel[] = [];

  @equal('credentials.length', 1) singleCredential!: boolean;

  loadCurrentEnvironmentCredentials = task({ drop: true }, async () => {
    /*
     * Clear the credentials array before we load them again.
     *
     * When we switch workspaces, we unload all records, but this
     * service still keeps references to the previously loaded credentials
     * and Ember throws a Glimmer error when loading them again. Clearing
     * them out fixes the bug.
     */

    this.set('credentials', []);

    let credentials = await this.store.query('api-credential', {
      environment_id: this.environment.current.id,
    });

    this.set('credentials', _sortBy(credentials, ['createdAt']).reverse());

    return credentials;
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'api-credentials': ApiCredentialsService;
  }
}
